import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// ✅ GET: Traer todos los choferes
export const getChoferes = async () => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/choferes`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener choferes",
    };
  }
};

// ✅ GET: Traer un chofer por ID
export const getChoferById = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/choferes/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener chofer",
    };
  }
};

// ✅ POST: Crear nuevo chofer
export const postChofer = async (choferData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/choferes`;

  try {
    const resp = await axios.post(url, choferData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear chofer",
    };
  }
};

// ✅ PUT: Actualizar chofer
export const putChofer = async (id, choferData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/choferes/${id}`;

  try {
    const resp = await axios.put(url, choferData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar chofer",
    };
  }
};

// ✅ DELETE: Desactivar chofer
export const deleteChofer = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/choferes/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar chofer",
    };
  }
};
